import _asyncToGenerator from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
export var invalidateAccessToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(accessToken, queryApiBase) {
    var _result$data;
    var data, response, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = JSON.stringify({
              query: "mutation logoutLsl($accessToken: String!, $clientId: String!) {\n              logoutLsl(accessToken: $accessToken, clientId: $clientId)\n            }",
              variables: {
                accessToken: accessToken,
                clientId: 'QantasShopping'
              }
            });
            _context.next = 3;
            return fetch(queryApiBase, {
              method: 'POST',
              cache: 'no-cache',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json; charset=utf-8'
              },
              body: data
            });
          case 3:
            response = _context.sent;
            _context.next = 6;
            return response.json();
          case 6:
            result = _context.sent;
            if (!result.errors) {
              _context.next = 9;
              break;
            }
            throw new Error(JSON.stringify(result.errors, null, 2));
          case 9:
            return _context.abrupt("return", result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.logoutLsl);
          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function invalidateAccessToken(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();